export default __webpack_public_path__ + "static/road-a4a47c1701bda8d00fad4ff97b1dc604.png";